module.exports = __webpack_public_path__ + "static/media/buscando_clases.7e11bdf4.svg";